import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tKgpco/Store/CustomHandlerCreator";

type HandlerType = CustomHandler<{ workOrderError: string }>;

export const DispatchWorkOrderError: HandlerType = props => {
    props.dispatch({
        type: "Custom/CheckoutReview/WorkOrderError",
        workOrderError: props.parameter.workOrderError,
    });
};

export const chain = [DispatchWorkOrderError];

const setWorkOrderError = createHandlerChainRunner(chain, "WorkOrderError");
export default setWorkOrderError;
